export default "<!-- <div id=\"wave-container\">\r\n    <div id=\"wave\">\r\n    </div>\r\n</div> -->"